module.exports = __webpack_public_path__ + "static/media/logo-color.0fd3ac33.png";